export default __webpack_public_path__ + "static/de-taalschat-09197505eeb7b7f5b3e6a95232d71811.png";